<template>
    <div role="separator" class="dropdown-divider"></div>
</template>

<script>
    export default {
        props: {}
    };
</script>
